import MessageBulk from './message-bulk'
import LocationBulk from './location-bulk'
import PhoneBulk from './phone-bulk'

export default {
  MessageBulk,
  LocationBulk,
  PhoneBulk
}
